import axios from 'axios';
import { showAlert } from '../../components/service/AlertService';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api/';

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});

// Interceptor to add Authorization header with token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to handle responses and errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Error:', error);

    if (error.code === 'ERR_NETWORK') {
      // Show a network alert message
      showAlert('NETWORK_ERROR');
    }

    // Handle TOKEN_NOT_VALID error
    else if (error.response?.data?.error?.code === 'TOKEN_NOT_VALID') {
      // Clear token and user from localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Show alert message
      localStorage.setItem('tokenEnd', true);

      // Redirect to main page (/) if not already there
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }

      // Reject the error to prevent further processing
      return Promise.reject(error);
    }

    // Handle 401 Unauthorized (for other cases)
    else if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default api;